import React from "react";
import { ReactTyped } from "react-typed";
export default function MyTypeWriter({ h }) {
  return (
    <h1 className="text-center pt-4">
      <ReactTyped
        strings={[h]}
        typeSpeed={50}
        backSpeed={50}
        backDelay={1000}
      />
    </h1>
  );
}
